<template>
  <div class="page-menu min-w"  @mouseover="mouseover" @mouseleave="mouseleave" :style="{height:(showDetail?'200px':'70px')}" id="myMenu">
    <div class="title" >
      <div class="show-w">
        <ul>
          <li v-for="(item,index) in titleList" :key="index" :class="{ active: index == checkIndex,en:lang=='en' }"
              :index="index"
              @click="toUrl(item)"
              v-if="isShow(item.isIndex)"
             >
            <label>{{item.name}}</label>
          </li>
        </ul>
      </div>
    </div>
    <div class="detail" :class="{'show':showDetail}">
      <div class="show-w">
        <ul>
          <li v-for="(item,index) in checkList" :key="index" @click="toUrl(item)"
              :class="{en:lang=='en' }"
              >
            <div class="detail-title">{{item.name}}</div>
            <div class="detail-explain">{{item.explain}}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import menuArray from './menu.array'
import i18n from '../lang'
export default {
  name: 'PageMenu',
  data () {
    return {
      titleList: this.getArray(),
      checkIndex:-1,
      showDetail:false,
      checkList:[{
        title:'..',
        explain:'..'
      }],
      showIndex:false,
      lang:this.$i18n.locale
    }
  },
  props:{
    getArray:{
      type:Function,
      default:()=>{
        return [];
      }
    }
  },
  watch:{
    $route(to){
      if(to.path!='/'){
        this.showIndex = true;
      }else{
        this.showIndex = false;
      }
      this.showDetail = false;
      this.checkIndex = -1;
    },
    '$i18n.locale'(newValue){
      this.lang = newValue
      this.titleList = this.getArray();
    }
  },
  methods:{
    mouseover(dom){
      const index = dom.target.getAttribute('index')||dom.target.parentNode.getAttribute('index')
      if(index){
        this.checkIndex = index;
        if(this.titleList[index].list){
          this.checkList = this.titleList[index].list;
          this.showDetail = true;
        }else{
          this.showDetail = false;
        }
      }
    },
    mouseleave(dom){
      this.showDetail = false;
      this.checkIndex = -1;
    },
    toUrl(item){
      if(item.url){
        const lang = localStorage.getItem('lang');
        if(lang=='en'){
          if(!item.hasEn){
            window.setMyLang('zh');
          }
        }else if(lang=='zh_tw'){
          if(!item.hasEn){
            window.setMyLang('zh');
          }
        }
        this.$router.push({path:item.url,query:{t:Date.now()}});
        window.scrollTo(0,0);
      }
    },
    isShow(isIndex){
      if(isIndex){
        if(this.showIndex){
          return true;
        }else{
          return false;
        }
      }
      return true;
    }
  },

}
</script>

<style scoped>
  .page-menu{
    width: 100%;
    z-index: 99;
  }
  .page-menu .title{
    background: #FF722F;
    width: 100%;
    z-index: 9;
    position:relative;
  }
  .page-menu .title ul{
    padding-left:292px;
    display: flex;
  }
  .page-menu .title ul li{
    float: left;
    margin-left: 80px;
    height: 70px;
    font-size: 18px;
    line-height: 70px;
    color: #FFFFFF;
    /*font-weight: bold;*/
    text-align: left;
  }
  .page-menu .title ul li.en{
    margin-left: 26px;
    font-size: 16px;
  }
  .page-menu .title ul li:first-child{
    margin-left: 0 !important;
  }
  .page-menu .title ul li.active label{
    position: relative;
  }
  .page-menu .title ul li.active label::before {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 25px;
    bottom: -10px;
    width: 80%;
    height: 4px;
    background: #fff;
  }
  .page-menu .detail{
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    width: 100%;
    opacity: 0;
    margin-top: -70px;
    z-index: 8;
    -webkit-transition: opacity 0.5s ease, -webkit-transform 0.5s ease;
    transition: opacity 0.5s ease, transform 0.5s ease, -webkit-transform 0.5s ease;
  }
  .page-menu .detail.show{
    -webkit-transition: opacity 0.5s ease, -webkit-transform 0.5s ease;
    transition: opacity 0.5s ease, transform 0.5s ease, -webkit-transform 0.5s ease;
    opacity: 1;
    -webkit-transform: translateY(70px);
    transform: translateY(70px);
  }
  .page-menu .detail ul{
    padding-left:172px;
  }
  .page-menu .detail ul li{
    float: left;
    width: 186px;
    height: 130px;
    font-size: 20px;
    text-align: left;
    box-sizing: border-box;
    cursor: pointer;
    /*transition: height 0.5s;*/
    /*-moz-transition: height 0.5s;*/
    /*-webkit-transition: height 0.5s;*/
    /*-o-transition: height 0.5s;*/
  }
  .page-menu .detail.show ul li{
    /*-moz-transition: height 0.5s;*/
    /*-webkit-transition: height 0.5s;*/
    /*-o-transition: height 0.5s;*/
  }
  .page-menu .detail ul li .detail-title{
    color: #FFFFFF;
    font-size: 16px;
    line-height: 22px;
    margin: 34px 15px 0 15px;
  }
  .page-menu .detail ul li.en .detail-title{
    font-size: 14px;
    margin: 30px 15px 0 15px;
  }
  .page-menu .detail ul li .detail-explain{
    color: #B1B1B1;
    font-size: 14px;
    line-height: 20px;
    margin: 10px 15px 0 15px;
  }
  .page-menu .detail ul li:hover{
    background: #555555;
  }
</style>



// WEBPACK FOOTER //
// src/components/PageMenu.vue